export default "__VITE_ASSET__waU4YcCh__"